import {computeIsLockedByInheritance} from "../pcb/derived";
import {allUidsSet} from "../selection/base";
import type {DocumentStoreState, ParameterizedSelector} from "../types";

/**
 * Derived selectors for PCB layout nodes - computed values
 */

/**
 * Selector to check if a PCB node is locked by inheritance.
 * A node is locked by inheritance if any of its ancestors are locked.
 * @param nodeUid The node UID to check
 * @returns True if the node is locked by inheritance
 */
export const isLockedByInheritance: ParameterizedSelector<string | undefined, boolean> = (
    nodeUid: string | undefined,
) => {
    return (state: DocumentStoreState): boolean => {
        return computeIsLockedByInheritance(state.pcbLayoutNodes, nodeUid);
    };
};

/**
 * Selector to check if a PCB node is selected.
 * Uses Set.has() for O(1) lookup performance instead of Array.includes().
 * @param nodeUid The node UID to check
 * @returns True if the node is selected
 */
export const isPcbNodeSelected: ParameterizedSelector<string, boolean> = (nodeUid: string) => {
    return (state: DocumentStoreState): boolean => {
        return allUidsSet(state).has(nodeUid);
    };
};
